<template>
  <div class="main-container box">
    <Tabs v-model="tab" v-if="userInfo.levelCode != 10002">
      <TabPane label="首页轮播图配置" name="bannerConfig" v-if="$units.pointAction('operate_3_0')"></TabPane>
      <TabPane label="热销产品配置" name="hotProductConfig" v-if="$units.pointAction('operate_3_1')"></TabPane>
      <TabPane label="弹窗广告配置" name="popUpConfig" v-if="$units.pointAction('operate_3_2')"></TabPane>
      <TabPane label="产品库分类配置" name="productLibrary" v-if="$units.pointAction('operate_3_3')"></TabPane>
      <TabPane label="产品库排序" name="productSorting" v-if="$units.pointAction('operate_3_4')"></TabPane>
      <TabPane label="个人中心广告配置" name="advertisementConfig"></TabPane>
      <TabPane label="头条banner配置" name="headlinesConfig" v-if="$units.isOkBao() || $units.isOkTX()"></TabPane>
      <TabPane label="中部banner配置" name="centerlinesConfig" v-if="$units.isOkBao()"></TabPane>
      <TabPane label="搜索配置" name="searchConfig" v-if="$units.isOkBao() || $units.isOkTX()"></TabPane>
      <TabPane label="培训banner" name="sourceConfig" v-if="$units.isOkBao()"></TabPane>
    </Tabs>

    <Tabs v-model="tab" v-if="userInfo.levelCode == 10002 && $units.pointAction('operate_3_1')">
      <TabPane label="热销产品配置" name="hotProductConfig"></TabPane>
    </Tabs>
    <component :is="tab"></component>
  </div>
</template>
<script>
import bannerConfig from './bannerConfig';
import sourceConfig from './sourceConfig';
import hotProductConfig from './hotProductConfig/index';
import popUpConfig from './popUpConfig';
import productLibrary from './productLibrary';
import productSorting from './productSorting';
import advertisementConfig from './advertisementConfig';
import headlinesConfig from './headlinesConfig';
import centerlinesConfig from './centerlinesConfig';
import searchConfig from './searchConfig';

export default {
  components: {
    bannerConfig,
    hotProductConfig,
    productLibrary,
    productSorting,
    popUpConfig,
    advertisementConfig,
    headlinesConfig,
    centerlinesConfig,
    searchConfig,
    sourceConfig,
  },

  created() {
    this.filtersTabList();
  },

  data() {
    return {
      tab: '',
      userInfo: JSON.parse(window.localStorage.getItem('userInfo')),
      tabList: [],
    };
  },

  methods: {
    filtersTabList() {
      if (this.userInfo.levelCode != '10002') {
        if (this.$units.pointAction('operate_3_0')) {
          this.tab = 'bannerConfig';
        } else if (this.$units.pointAction('operate_3_1')) {
          this.tab = 'hotProductConfig';
        } else if (this.$units.pointAction('operate_3_2')) {
          this.tab = 'popUpConfig';
        } else if (this.$units.pointAction('operate_3_3')) {
          this.tab = 'productLibrary';
        } else if (this.$units.pointAction('operate_3_4')) {
          this.tab = 'productSorting';
        }
      } else if (this.userInfo.levelCode == '10002' && this.$units.pointAction('operate_3_1')) {
        this.tab = 'hotProductConfig';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.box {
  /deep/ {
    .ivu-tabs-bar {
      border-bottom: 1px solid #ececec;
    }
    .ivu-tabs-ink-bar {
      display: none;
    }
    .ivu-tabs-tab {
      padding: 9px 0 10px;
      margin-right: 44px;
      font-size: 14px;
      color: #515c6f;
    }
    .ivu-tabs-tab-active {
      position: relative;
      color: #236dff;
      &::before {
        content: '';
        position: absolute;
        left: 0;
        bottom: 1px;
        height: 2px;
        width: 100%;
        background-color: #236dff;
      }
    }
  }
}

/deep/ .ivu-tabs-tab {
  padding-top: 0 !important;
  font-size: 14px;
}
</style>
